module.exports = __webpack_public_path__ + "img/startapp-logo.1e95601e.png";